import { $http } from "@/plugins/api";

const state = {
  targetedUsers: [],
};

const getters = {
  targetedUsers: (state) => state.targetedUsers,
};

const actions = {
  async getTargetedUsers({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT
      }/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/targets?${filterParams.toString()}`,
    );

    commit("setTargetedUsers", res.data.data);
  },
};

const mutations = {
  setTargetedUsers: (state, data) => (state.targetedUsers = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
